import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SearchAppBar from './SearchAppBar';
import TableView from './TableView';
import { getQueryParams, normalizeFilterValue } from './util'; // Adjust path as needed
import { updateFilterField } from '../redux/actions';

const ALLOWED_QUERY_KEYS = ["neighborhood", "document", "search", "project", "startDate", "endDate"];
function RecordsLib() {
  const dispatch = useDispatch();
  const filters = useSelector(state => state.filters);


  const uniqueProjectNames = useSelector(state => state.defaultDropdownOptions.uniqueProjectNames);
  const uniqueDocumentTypes = useSelector(state => state.defaultDropdownOptions.uniqueDocumentTypes);
  const uniqueNeighborhood = useSelector(state => state.defaultDropdownOptions.uniqueNeighborhood);

  useEffect(() => {
  const dropdownsReady = (
    Array.isArray(uniqueProjectNames) && uniqueProjectNames.length > 0 &&
    Array.isArray(uniqueDocumentTypes) && uniqueDocumentTypes.length > 0 &&
    Array.isArray(uniqueNeighborhood) && uniqueNeighborhood.length > 0
  );
  if (!dropdownsReady) {
    return; // Wait until all options are loaded
  }
    const updateParams = () => {
      const params = new URLSearchParams(window.location.search);
      const queryParams = getQueryParams(params);

      const hasValidKey = ALLOWED_QUERY_KEYS.some(key => params.has(key));

      if (!hasValidKey) return; // Skip update if no valid keys 
      //Getting the exact values from the dropdowns
      const normalizedDocType = normalizeFilterValue(queryParams.docTypeValue, uniqueDocumentTypes);
      const normalizedNeighborhood = normalizeFilterValue(queryParams.neighborhoodValue, uniqueNeighborhood);
      const normalizedProj = normalizeFilterValue(queryParams.projId, uniqueProjectNames, true);

      // Dispatch filters to Redux store // new values or vales from reducer
      const filterFields = {
        docTypeValue: normalizedDocType || '',
        neighborhoodValue: normalizedNeighborhood || '',
        projId: normalizedProj?.id || '',
        searchText: queryParams.searchText || '',
        startDate: queryParams.startDate || filters.startDate,
        endDate: queryParams.endDate || filters.endDate
      };
        // Compare each value with initState.filters and only dispatch if changed
        Object.entries(filterFields).forEach(([key, value]) => {
          const defaultValue = filters[key];

          // Compare Dates by time value, Objects by JSON, and others directly
          const isDifferent = (() => {
            if (defaultValue instanceof Date && value instanceof Date) {
              return defaultValue.getTime() !== value.getTime();
            }
            if (typeof defaultValue === 'object' && typeof value === 'object') {
              return JSON.stringify(defaultValue) !== JSON.stringify(value);
            }
            return defaultValue !== value;
          })();

          if (isDifferent) {
            dispatch(updateFilterField(key, value));
          }
        });

    };

    updateParams();

    window.addEventListener('popstate', updateParams);
    window.addEventListener('load', updateParams);
    window.addEventListener('hashchange', updateParams);

    return () => {
      window.removeEventListener('popstate', updateParams);
      window.removeEventListener('load', updateParams);
      window.removeEventListener('hashchange', updateParams);
    };
  }, [dispatch, uniqueDocumentTypes, uniqueNeighborhood, uniqueProjectNames]);

  return (
    <div className="RecordsLib">
      <SearchAppBar />
      <TableView />
    </div>
  );
}

export default RecordsLib;
